/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { InputField } from '../../../../../Components/FormFields/InputField';

/**
 * VoucherCode Component
 * @returns {JSX.Element}
 * @constructor
 */
export function VoucherCode(props) {
  const {
    voucherCode,
    updatePreviewData,
  } = props;
  const { t } = useTranslation('translations');
  const { values } = useFormikContext();

  const renderVoucherField = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={9}>
        <InputField name={voucherCode.name} label={voucherCode.label} fullWidth />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Button
          variant="contained"
          color="primary"
          sx={{
            width: '100%',
            height: '56px',
          }}
          onClick={() => {
            if (values.voucherCode) {
              updatePreviewData();
            }
          }}
        >
          {t('submitVoucherCode')}
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <Grid container mt={4}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight: 'bold',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: '#49ad33',
          }}
        >
          {t('voucherCodeHeader')}
        </Typography>
        <Box mt={2}>
          {t('voucherCodeDescription')}
        </Box>
        <Box mt={2}>
          {renderVoucherField()}
        </Box>
      </Grid>
    </Grid>
  );
}

VoucherCode.propTypes = {
  voucherCode: PropTypes.object.isRequired,
  updatePreviewData: PropTypes.func.isRequired,
};
